import React, { useEffect  } from "react";
// import swal from "sweetalert";
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { connect } from "react-redux";
//import {Button, Grid} from '@mui/material';
import { Grid} from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
import UserItem from "../components/UserItem";
// import { loadUserList, addNewUser, loadUserPermissionsList, updateUserPermissions, updateUserRole, importUsers, loadRoleList } from "../api/userapi";
import { loadUserList, addNewUser, loadUserPermissionsList, updateUserPermissions, updateUserRole, loadRoleList } from "../api/userapi";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import { getUserList,  getUserLoading, getUserDialogStatus, getRolesList, getPermissions } from "../selector/selectors";
import PermissionModal from "../components/PermissionModal";
import { useSelector } from 'react-redux';
//import AddUserForm from "../components/AddUserForm";
// import ImportUserModal from "../components/ImportUserModal";
// import * as XLSX from 'xlsx';
// import ImportUserEditModal from "../components/ImportUserEditModal";
import { Link } from "react-router-dom";
import { getUserPermissionRolesData } from "../api/userpermissionsapi";
import { loadPermissionsList } from "../api/permissionsapi";


function ManageUsers({
  isLoading,
  userList,
  startLoadingUsers,
  //addNewUser,
  startLoadingRole,
  roleList,
  //userDialogBoxStatus,
  permissionList,
  startLoadingPermissions
}) {
    
    const dispatch = useDispatch();
    let userType = 1;
    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchValue, setSearchValue] = React.useState('');
    const [openPermissionModal, setOpenPermissionModal]     = React.useState(false);
    const [updatedPermissionList, setUpdatedPermissionList] = React.useState([]);
    const [updatedUserList, setupdatedUserList] = React.useState([]);
    const [selectedUserId, setSelectedUserId]   = React.useState('');
    // const [openImportUserModal, setOpenImportUserModal]         = React.useState(false);
    // const [openImportUserEditModal, setOpenImportUserEditModal] = React.useState(false);
    // const [selectFile, setSelectFile]     = React.useState("");
    // const [fileContents, setFileContents] = React.useState([]);
    const [updatedRoleList, setUpdatedRoleList]        = React.useState([]);
    // const [disableImportForm, setDisableImportForm]    = React.useState(true);
    //const permissionList        =  useSelector((state) => state.permissionData.permissionsData);
    const userPermissionsList   =  useSelector((state) => state.userData.userPermissionsData);
    const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
    //const adminRolesList        =  useSelector((state) => state.permissionData.adminRolesData);
    // const [fields, setFields] = useState([{
    //   first_name    : '',
    //   last_name     : '',
    //   email         : '',
    //   role_type     : '',
    //   temp          : false,
    //   user_type     : userType
    // }]);


    // const handleAddInput = () => {
    //   setFields([...fields, { first_name: "", last_name: "", email: "" , role_type: "", temp: false, user_type: userType}]);
    // };

    useEffect(() => {
      // startLoadingUsers('', previousController);
      startLoadingUsers(userType,'');
      startLoadingRole();
      startLoadingPermissions();
    }, [startLoadingRole,startLoadingUsers,userType,startLoadingPermissions]);

    useEffect(() =>{
      setupdatedUserList(userList);
      let roleUpdateList = roleList?.filter(val => val.role_type === '1');
      setUpdatedRoleList(roleUpdateList);
    },[userList,roleList])


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };


    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingUsers(userType,searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingUsers(userType,searchValue,0,event.target.value);
    }

    // const handleFormData = async () => {
    //   let error = false;
    //   let emailError = false;
    //   fields.map((val) => (val.first_name === '' ||  val.last_name === '' || val.email === '' || val.role_type === '') ? error = true : error)
    //   if(error){
    //     swal("Oops!", "Please fill required fields!", "error");
    //     return false;
    //   }
    //   fields.map((val) => (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val.email)) ? emailError : emailError = true)
    //   if(emailError){
    //     swal("Oops!", "Email address is not vaild!", "error");
    //     return false;
    //   }
    //   dispatch(addNewUser(fields,userType,page));
    //   setFields([{ first_name: "", last_name: "", email: "" , role_type: "", temp: false, user_type: userType}]);
    // }

    const handleSearchUser = (event) => {
      setSearchValue(event.target.value);
      startLoadingUsers(userType,event.target.value);
    };

    const handlePermissionDialogOpen = (id) => {
      setOpenPermissionModal(true);
      setSelectedUserId(id);
      dispatch(loadUserPermissionsList(id));
    }

    const handlePermissionDialogClose = () => {
      setOpenPermissionModal(false);
      setSelectedUserId('');
    };

    useEffect(() => {
      const data = permissionList.map(permission => {
        let checkedVal = false;
        userPermissionsList?.filter(userPermission => userPermission.permission_id === permission.id.toString() ?  checkedVal = true  : checkedVal);
        if(checkedVal){
          return {...permission,checked:true}
        } else {
          return {...permission,checked:false}
        } 
      });
      setUpdatedPermissionList(data);
    },[permissionList,userPermissionsList]);

    const handleSwitchChange = (id) => (event) =>{
      const updatedData = updatedPermissionList.map(permission => {
        if(permission.id === id){
          return {...permission,checked:event.target.checked}
        }
        return permission;
      });
      setUpdatedPermissionList(updatedData);
    };

    const handleSaveData = () => {
      let permissions = updatedPermissionList;
      dispatch(updateUserPermissions(selectedUserId,permissions));
      setOpenPermissionModal(false);
      setTimeout (() => {
        dispatch(getUserPermissionRolesData());
      }, 1000);
    }

    const handleRoleChange = (event,userId) => {
      
      dispatch(updateUserRole(event.target.value,userId,userType,page));
      const newUserList = updatedUserList?.data?.map(item => (item.id === userId  ? { ...item,roleId:event.target.value} : item));
      setupdatedUserList({...updatedUserList,data:newUserList});
    }
    
    // const changeHandler = (e,index) => {
    //  // setUserData((prevState) =>
    //   //({...prevState, [e.target.name]: e.target.value }));
    //   let { name, value,checked } = e.target;
    //   let onChangeValue = [...fields];
    //   onChangeValue[index][name] =  name === 'temp' ? (checked ? true : false)  : value;
    //   setFields(onChangeValue);
    // };


    // const handleDeleteInput = (index) => {
    //   const newArray = [...fields];
    //   newArray.splice(index, 1);
    //   setFields(newArray);
    // };

    // const handleImportUserModalOpen = () => {
    //   setOpenImportUserModal(true);
    // }

    // const handleImportUserModalClose = () => {
    //   setOpenImportUserModal(false);
    //   setSelectFile('');
    // };

    // const handleFileChange = (event) => {
    //   let fileUploadType = event.target.files[0]?.type;
    //   let type1 = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    //   let type2 = 'application/vnd.ms-excel';
    //   if(!fileUploadType.match(type1) && !fileUploadType.match(type2)){
    //     setSelectFile('');
    //     event.target.value = null;
    //     swal({
    //       title: 'Error',
    //       text: 'Please upload vaild file with extension xlsx, xls.',
    //       icon: "error",
    //       dangerMode: true,
    //     });
    //     return;
    //   }
    //   setSelectFile(event);
    //   var files = event.target.files, f = files[0];
    //   var reader = new FileReader();
    //   reader.onload = function (event) {
    //       var data = event.target.result;
    //       let workbook = XLSX.read(data, {type: 'binary'});
    //       const sheetName = workbook.SheetNames[0];
    //       const userData  = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
    //       setFileContents(userData);
    //   };
    //   reader.readAsBinaryString(f)
    // }

    // const handleReadImportUsers = () => {
    //   if(selectFile === ''){
    //     swal({
    //       title: 'Error',
    //       text: 'Please upload file.',
    //       icon: "error",
    //       dangerMode: true,
    //     });
    //     return;
    //   }
    //   setOpenImportUserModal(false);
    //   setOpenImportUserEditModal(true);
    // }

    // const changeImportHandler = (e,index) => {
    //   let { name, value, checked } = e.target;
    //   let onChangeValue = [...fileContents];
    //   onChangeValue[index][name] =  name === 'Temporary' ? (checked ? true : false)  : value;
    //   setFileContents(onChangeValue);
    // };

    // const handleImportFormClose = () => {
    //   setOpenImportUserEditModal(false);
    //   setFileContents([]);
    //   setSelectFile('');
    //   setDisableImportForm(true);
    // }

    // const handleEditImportForm = () => {
    //   setDisableImportForm(false);
    // }

    // const handleImportFormData = async () => {
    //   let error = false;
    //   let emailError = false;
    //   let keysExist  = fileContents.every(item => item.hasOwnProperty("FirstName") && item.hasOwnProperty("LastName") && item.hasOwnProperty("EmailAddress") && item.hasOwnProperty("UserRole"));

    //   fileContents.map((val) => (val.FirstName === '' ||  val.LastName === '' || val.EmailAddress === '' || val.UserRole === '') ? error = true : error)
    //   if(error || !keysExist){
    //     swal("Oops!", "Please fill required fields!", "error");
    //     return false;
    //   }
    //   fileContents.map((val) => (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val.EmailAddress)) ? emailError : emailError = true)
    //   if(emailError){
    //     swal("Oops!", "Email address is not vaild!", "error");
    //     return false;
    //   }
    //   let updateContents = fileContents.map((item) => {
    //     if(typeof item.UserRole === 'string'){
    //       let selectedId = updatedRoleList.find(val => val.name === item?.UserRole)?.id;
    //       return {...item,UserRole:selectedId};
    //     } else {
    //       return item;
    //     }
    //   });
    //   dispatch(importUsers(updateContents,userType,page));
    //   setOpenImportUserEditModal(false);
    // }
    //console.log('userPermissionsList',userPermissionsList)
    return (
      <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
         <TabContext value={value}>
            <Grid item xs={12} md={12} lg={12} >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="">
                  {list?.userDetails?.role_id === 1 &&
                    <Link className="tabingLinks" to="/web/roles">Roles</Link>
                  }
                  <Tab label="Users" value="1" />
                  {/* <Link className="tabingLinks" to="/web/app/users">SiteTech users</Link> */}
                  {list?.userDetails?.role_id === 1 &&
                    <>
                    <Link className="tabingLinks" to="/web/permissions">Access Control</Link>
                    <Link className="tabingLinks" to="/web/controller-permissions">Controller Access Control</Link>
                    </>
                  }
                </TabList>
              </Box>
              <Box sx={{paddingTop:'16px', borderBottom: 1, borderColor: 'divider' }}>
                <TabList aria-label="">
                  {list?.userDetails?.role_id === 1 &&
                    <Tab label="Rehlink Sphere Users" value="1" />
                  }
                  <Link className="tabingLinks" to="/web/app/users">Rehlink users</Link>
                </TabList>
              </Box>
              <TabPanel value="1" sx={{p:0,pt:2}}>
                <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                  <Grid xs={5} sm={6} md={3}>
                    <SearchBoxComponent
                      handleChangeTextValue = {(e)=>handleSearchUser(e,'')}
                      label='Search Email / Name'
                    />   
                  </Grid>
                  {/* <Grid>
                    <Grid container sx={{display: 'flex', justifyContent: 'space-between'}}>
                      <Button 
                          sx={{mr:1}}
                          variant="contained"
                          size="medium"
                          color="primary"
                          onClick={handleAddInput}
                      >
                          Add User
                      </Button> 

                      <Button 
                          variant="contained"
                          size="medium"
                          color="primary"
                          onClick={handleImportUserModalOpen}
                      >
                        Import Users
                      </Button>
                    </Grid>
                  </Grid> */}
                </Grid>
                {/* <AddUserForm fields={fields} changeHandler={changeHandler} adminRolesList={updatedRoleList} handleFormData={handleFormData} handleDeleteInput={handleDeleteInput} /> */}
                <UserItem 
                  roleList={updatedRoleList} 
                  handlePermissionDialogOpen={handlePermissionDialogOpen} 
                  users={updatedUserList} 
                  page={page} 
                  rowsPerPage={rowsPerPage} 
                  handleChangeRowsPerPage={handleChangeRowsPerPage} 
                  handleChangePage={handleChangePage} 
                  handleRoleChange={handleRoleChange}
                  userType={userType}
                />
              </TabPanel>
            </Grid>
          </TabContext>
          {/* <UsersModal
              open={userDialogBoxStatus}
              value={userData}
              setUserData={setUserData}
              handleFormData={handleFormData}
              roleList={adminRolesList}
          /> */}
          {/* <ImportUserModal 
              selectFile={selectFile}
              open={openImportUserModal}
              handleImportClose={handleImportUserModalClose}
              handleFileChange={handleFileChange}
              handleReadImportUsers={handleReadImportUsers}
          />
          <ImportUserEditModal 
            open={openImportUserEditModal}
            users={fileContents}
            adminRolesList={updatedRoleList}
            changeImportHandler={changeImportHandler}
            handleImportFormData={handleImportFormData}
            handleImportFormClose={handleImportFormClose}
            disableImportForm={disableImportForm}
            handleEditImportForm={handleEditImportForm}
          /> */}
          <PermissionModal
              updatedPermissionList={updatedPermissionList}
              open={openPermissionModal}
              handlePermissionDialogClose={handlePermissionDialogClose}
              handleSaveData={handleSaveData}
              handleSwitchChange={handleSwitchChange}
          />
        </Grid>
      </Box>
    );
}
const mapStateToProps = (state) => ({
  isLoading             :   getUserLoading(state),  
  userList              :   getUserList(state), 
  userDialogBoxStatus   :   getUserDialogStatus(state), 
  roleList              :   getRolesList(state), 
  permissionList        :   getPermissions(state), 
});

const mapDispatchToProps = (dispatch) => ({
  addNewUser:(data,userType,page)  => dispatch(addNewUser(data,userType,page)),
  startLoadingRole:()              => dispatch(loadRoleList()),
  startLoadingUsers:(userType,searchText, page,rowsPerPage) => dispatch(loadUserList(userType,searchText, page,rowsPerPage)),
  startLoadingPermissions: ()      => dispatch(loadPermissionsList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);

